import React, { useEffect, useState } from 'react';
import './style.scss';
import '../style.scss';
import { MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT, TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT } from 'global/environment';
import { QrCodeMyVNPTService } from '../services/QrCodeMyVNPTService';
import { TRANSACTION_STATUS, TRANSACTION_TYPE } from '../constant/contanst';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import PaymentResult from '../PaymentResult/PaymentResult';

const Paying = ({ dataTransaction, data, token }) => {
  const history = useHistory();
  const [countCheckTranStatus, setCountCheckTranStatus] = useState(0);

  useEffect(() => {
    if(dataTransaction) {
      CheckTranStatus();
    }
    return () => clearInterval();
  }, [dataTransaction]);

  const CheckTranStatus = async () => {
    const interval = setInterval(() => {
      setCountCheckTranStatus((prevCount) => {
        if (prevCount >= Number(MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT)) {
          clearInterval(interval);
          return prevCount;
        }
        checkQrTransactionInfo({
          session: data?.token,
          msisdn: data?.result?.msisdn,
          transactionId: dataTransaction?.transactionId
        })
        return prevCount + 1;
      });
    }, Number(TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT));

    return () => clearInterval(interval);
  }

  const checkQrTransactionInfo = async (payload) => {
    try {
      await QrCodeMyVNPTService.queryTransactionInfo(payload, res => {
        if (res?.transactionStatus == TRANSACTION_STATUS.SUCCESS) {
          sessionStorage.setItem('dataQueryTransactionInfo', JSON.stringify(res))
          const encodedToken = encodeURIComponent(token);
          history.push('/thanhtoan/roaming/success?token=' + encodedToken);
        } else if (res?.transactionStatus == TRANSACTION_STATUS.FAIL) {
          sessionStorage.setItem('dataQueryTransactionInfo', JSON.stringify(res))
          const encodedToken = encodeURIComponent(token);
          history.push('/thanhtoan/roaming/fail?token=' + encodedToken);
        } else if (res?.transactionStatus == TRANSACTION_STATUS.TIMEOUT) {
          //Timeout
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PaymentResult type={TRANSACTION_TYPE.PROCESS} />
  );
}

export default React.memo(Paying);
